import { useMemo } from 'react';
import DeliveredFile from './DeliveredFile';
import { ShippingDocumentsTypes } from 'src/entities/Order';

const DeliveryData = ({
  orderNumber,
  shippingDocuments,
  uploadDocument,
  canEditDeliveredData,
}) => {
  const deliveredDocument = useMemo(() =>
    shippingDocuments.find(
      doc => doc.documentType === ShippingDocumentsTypes.DELIVERY_RECEIPT,
    ),
  );

  return (
    <div className="row d-flex items-start pt-4">
      <div className="col-12 col-md-4">
        <h4 className="mt-2 mb-0 fw-light">Dados de entrega</h4>
        <p className="text-secondary">
          Registre apenas quando o pedido for entregue.
        </p>
      </div>
      <div className="col-12 col-md-4">
        <DeliveredFile
          deliveredDocument={deliveredDocument}
          canEditDeliveredData={canEditDeliveredData}
          uploadDocument={uploadDocument}
          orderNumber={orderNumber}
        />
      </div>
    </div>
  );
};

export default DeliveryData;
